import { gql } from 'graphql-tag';
import type { TypedDocumentNode } from '@apollo/client';
import type { IGetStaffData } from '../types';

export const GET_STAFF: TypedDocumentNode<IGetStaffData> = gql`
  query getStaff {
    viewer {
      id
      site {
        id
        staff {
          active
          confirmed
          email
          firstName
          id
          lastName
          phone
          role
          room {
            id
            title
          }
          welcomed
        }
      }
    }
  }
`;
